import { jsx as _jsx } from "react/jsx-runtime";
import { Banner } from '#pplx/frontend/aether/components/Banner/index.js';
/** Matches the input's horizontal inset; the slot container owns vertical spacing. */
export function InputNotice({ message, leadingAccessory, onClose, variant = 'default', role, }) {
    return (_jsx("div", { className: "px-3", role: role, children: _jsx(Banner, { title: message, leadingAccessory: leadingAccessory, onClose: onClose, variant: variant }) }));
}
//# sourceMappingURL=InputNotice.js.map